export enum Sources {
  MerlinxWTG = 693,
  GenericWTG = 33
}
